"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLessonContentByEnvDataMock = exports.getLessonContentByEnvMock = void 0;
exports.getLessonContentByEnvMock = {
    signedUrl: 'fakeurl',
    displayName: 'SQL Injection',
};
exports.getLessonContentByEnvDataMock = {
    steps: [
        {
            title: 'SQL Injection',
            content: [
                {
                    content: 'Lesson Content',
                    action: 'Lesson Action',
                },
            ],
        },
    ],
    variables: [
        {
            key: 'password',
            value: '""',
            type: 'parameter',
        },
        {
            key: 'email',
            value: '""',
            type: 'parameter',
        },
        {
            key: 'small',
            value: false,
            type: 'parameter',
        },
    ],
    codeWalkthroughs: [
        {
            id: 650,
            language: 'java',
            locale: 'en',
            title: 'sql_injection1',
            uuid: '60f8225fb3e1260c47ee177a',
        },
    ],
    allowSkipSteps: true,
    isSavedWithKeys: true,
    useUserLocale: true,
    summary: ['Summary 1', 'Summary 2', 'Summary 3', 'Summary 4'],
    intro: 'Intro',
    translatedTo: {
        fr: true,
        es: true,
        de: true,
        pt: true,
        ko: true,
        ja: true,
    },
};
